import * as actions from './actions';

import { getFinalTemplateSelection, getSelectedTemplate, getSpecialTemplates } from './selectors';

import { TemplateType } from './constants';
import reducers from './reducers';

let selectors = { getSelectedTemplate, getFinalTemplateSelection, getSpecialTemplates };
const template = { reducers, actions, selectors, TemplateType };
export default template;
